import { render, staticRenderFns } from "./newFormList.vue?vue&type=template&id=bf229cd0&scoped=true"
import script from "./newFormList.vue?vue&type=script&lang=js"
export * from "./newFormList.vue?vue&type=script&lang=js"
import style0 from "./newFormList.vue?vue&type=style&index=0&id=bf229cd0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf229cd0",
  null
  
)

export default component.exports